<template>
  <div class="firstInterview">
      <div class="main">
        <ul class="content">
          <li @click="$router.push({path:'/consultant/newstudent/main/firstInterviewPartA',query:{...$route.query,show:(status==3||status==4)?'aa':'bb'}})">
            <img src="/imgs/xueyezixun/components/interviewPopup/duigou.png" alt=""  class="finish" :style="{display:(status==3||status==4)?'block':''}">
            <div class="title">家长问卷访谈</div>
            <div class="nextbottom">
              <img src="/imgs/xueyezixun/components/interviewPopup/fangtan.png" alt="">
              <p></p>
            </div>
          </li>
          <!-- <li @click="$router.push({path:'/consultant/newstudent/main/firstInterviewPartB',query:{...$route.query,show:(status==2||status==4)?'aa':'bb'}})">
            <img src="/imgs/xueyezixun/components/interviewPopup/duigou.png" alt=""  class="finish" :style="{display:(status==2||status==4)?'block':''}">
            <div class="title">partB</div>
            <div class="nextbottom">
              <img src="/imgs/xueyezixun/components/interviewPopup/jiedu.png" alt="">
              <p>测评报告解读</p>
            </div>
          </li> -->
          <!-- <li @click="$router.push({path:'/consultant/newstudent/main/firstInterviewPartB2',query:{...$route.query,show:(status==2||status==4)?'aa':'bb'}})">
            <img src="/imgs/xueyezixun/components/interviewPopup/duigou.png" alt=""  class="finish" :style="{display:(status==2||status==4)?'block':''}">
            <div class="title">partB</div>
            <div class="nextbottom">
              <img src="/imgs/xueyezixun/components/interviewPopup/jiedu.png" alt="">
              <p>测评报告解读</p>
            </div>
          </li> -->
        </ul>
      </div>
    <Popup v-if="popup_bool" :inter-view="interView" :status="status" :query="$route.query" :getPopupBool="getPopupBool"></Popup>
  </div>
</template>

<script>
import Popup from '@/components/xueyezixun/InterviewPopup'
export default {
  name: "firstInterview",
  components:{Popup},
  data(){
    return {
      studentId:this.$route.query.studentId,
      studentName:'',
      reportId:'',
      interView:[{
        category:1,
        interViewTheme:'首次访谈'
      }],
      popup_bool:false,
      // popup_bool:true,
      status:1
    }
  },
  methods:{
    toParent(){
      this.$emit('event1','>首次访谈')
    },
    getPopupBool(bool) {
      this.popup_bool= bool
    },
    getPopupData(obj){
      this.interViewData=obj
    },
    getData(){
      this.$ajax.post(this.G_acapi + this.ports.consultant.student.interView.process,{
        studentId:this.$route.query.studentId
      },{
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then(res=>{
        if(res.data.code==2000){
          const { status } = res.data.data;
          this.status = status
          console.log(status)
          if(status==1){
            console.log(666)
            this.popup_bool=true;
            console.log(this.popup_bool)
          }
        }else{
        }
      })
    }
  },
  mounted() {
    this.getData()
    this.toParent()
  },
}
</script>

<style scoped lang="less">
  .firstInterview{
    .main{
      width: 1200px;
      height: 630px;
      margin: 0  auto;
      background: #fff;
      overflow: hidden;
      .content{
        width: 736px;
        height: 380px;
        margin:100px auto;
        display: flex;
        justify-content: center;
        li{
          width: 314px;
          height: 100%;
          cursor: pointer;
          position: relative;
          .title{
            height: 48px;
            background: #7BC6F2;
            text-align: center;
            line-height: 48px;
            font-size: 30px;
            color:#fff;
          }
          .nextbottom{
            height: 330px;
            border:1px solid #EBEBEB;
            img{
              display: block;
              margin: 20px auto;
            }
            p{
              margin-top: 50px;
              font-size: 18px;;
              font-weight: 500;
              color: #3d90f6;
              line-height: 25px;
              text-align: center;
            }
          }
          .finish{
            position: absolute;
            left: 0;
            top: 0;
            display: none;
          }
        }
      }
    }
  }
</style>